import Card from 'components/card';
import LineChart from 'components/charts/LineChart';
import { lineChartOptionsOverallRevenue } from 'config/charts';
import { useState } from 'react';
import { MentorshipStats } from 'utils/dashboardDataHelper';
import { MdTrendingUp, MdChat, MdVideoCall, MdMoreHoriz } from 'react-icons/md';

function ConnectionsOverview() {
  const [mentorshipStats] = useState<MentorshipStats>({
    acceptedRatio: "83.4",
    lineChartData: [
      { 
        name: "Requested", 
        data: [180, 345, 487, 688, 877, 1033, 1211, 1406, 1573, 1756, 1928, 2108] 
      },
      { 
        name: "Accepted", 
        data: [74, 142, 201, 284, 362, 426, 499, 580, 649, 725, 797, 869] 
      },
    ],
    totalRequested: 2108,
    totalAccepted: 869,
  });

  const newOptions = {
    ...lineChartOptionsOverallRevenue,
    colors: ['#422AFB', '#39B8FF'],
    chart: {
      ...lineChartOptionsOverallRevenue.chart,
      dropShadow: {
        ...lineChartOptionsOverallRevenue.chart.dropShadow,
        color: '#422AFB',
      },
    },
  };


  return (
    <Card extra={'h-[420px] pb-8 px-6 pt-6'}>
      {/* Card Title */}
      <div className="mb-4 px-3">
        <h3 className="text-xl font-bold text-navy-700 dark:text-white">Connections Overview</h3>
        <p className="text-sm text-gray-600">Mentorship journey from initial requests to final outcomes</p>
      </div>
      
      <div className="flex justify-between px-3 pt-1">
        <div className="bg-gradient-to-r from-brand-500/5 to-brand-500/10 rounded-xl p-3 border border-brand-500/20 flex items-center gap-6">
          {/* Main Metric */}
          <div className="flex items-center gap-3 flex-shrink-0">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-500/10 relative group">
              <MdTrendingUp className="text-brand-500 text-xl" />
              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10">
                % of existing users involved in mentorship
              </div>
            </div>
            <div>
              <p className="text-3xl font-bold text-navy-700 dark:text-white">
                {mentorshipStats.acceptedRatio}%
              </p>
              <p className="text-base font-medium text-gray-600">
                Conversion
              </p>
            </div>
          </div>
          
          {/* Divider */}
          <div className="w-px h-12 bg-brand-500/20"></div>
          
          {/* Horizontal Funnel Metrics */}
          <div className="flex items-center gap-4 flex-1">
            <div className="text-center flex-1">
              <div className="flex items-center justify-center gap-2 mb-1">
                <div className="relative group">
                  <MdChat className="text-blue-500 text-lg" />
                  <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10">
                    % of users in mentorship who sent messages
                  </div>
                </div>
                <span className="text-base font-bold text-navy-700 dark:text-white">78.4%</span>
              </div>
              <div className="text-sm text-gray-600">Messages</div>
            </div>
            
            <div className="text-gray-300 text-sm">→</div>
            
            <div className="text-center flex-1">
              <div className="flex items-center justify-center gap-2 mb-1">
                <div className="relative group">
                  <MdVideoCall className="text-purple-500 text-lg" />
                  <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10">
                    % of users who scheduled meetings
                  </div>
                </div>
                <span className="text-base font-bold text-navy-700 dark:text-white">23.1%</span>
              </div>
              <div className="text-sm text-gray-600">Meetings</div>
            </div>
            
            <div className="text-center flex-1">
              <div className="flex items-center justify-center gap-2 mb-1">
                <div className="relative group">
                  <MdMoreHoriz className="text-orange-500 text-lg" />
                  <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10">
                    Mentorships continuing off-platform
                  </div>
                </div>
                <span className="text-base font-bold text-navy-700 dark:text-white">34.7%</span>
              </div>
              <div className="text-sm text-gray-600">External</div>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center">
          <select className="mb-3 mr-2 flex items-center justify-center text-sm font-bold text-gray-600 hover:cursor-pointer dark:!bg-navy-800 dark:text-white">
            <option value="monthly">Monthly</option>
            {/* <option value="yearly">Yearly</option> */}
            {/* <option value="weekly">Weekly</option> */}
          </select>
        </div>
      </div>

      {/* Charts */}
      <div className="flex h-full w-full flex-row sm:flex-wrap lg:flex-nowrap 2xl:overflow-hidden">
        <div className="h-full w-full">
        {mentorshipStats.lineChartData[0].data.length > 0 && (
            <LineChart
              chartData={mentorshipStats.lineChartData}
              chartOptions={newOptions}
            />
          )}
        </div>
      </div>
    </Card>
  );
}

export default ConnectionsOverview;